import React, { useRef, useState, useLayoutEffect, useEffect } from 'react'
import styled, { keyframes } from 'styled-components'
import { NavLink as RouterNavLink } from 'react-router-dom'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import BurgerImg from '../assets/Burger.svg'
import LogoImg from '../assets/logo.png'
import Icon1 from '../assets/icon1.svg'
import Icon2 from '../assets/icon2.svg'
import Icon3 from '../assets/icon3.svg'
import Icon4 from '../assets/icon4.svg'
import Icon5 from '../assets/Trefle.svg'
import Icon6 from '../assets/Coeur.svg'
import C1 from "../assets/carreau.png"
import C2 from "../assets/coeur.png"
import C3 from "../assets/pique.png"
import C4 from "../assets/trefle.png"

import ImgImp from '../assets/joker-page-1.png'


const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`

const NavbarContainer = styled.nav`
  width: 100%;
  padding: 0 2rem;
  height: 60px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  position: relative;
  background: #000;
  @media (max-width: 900px) {
    grid-template-columns: auto 1fr auto;
  }
`

const LogoWrapper = styled(RouterNavLink)`
  justify-self: start;
  display: flex;
  align-items: center;
`

const Logo = styled.img`
  height: 40px;
  cursor: pointer;
`

const NavLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  grid-column: 2;
  @media (max-width: 900px) {
    display: none;
  }
`

const StyledNavLink = styled(RouterNavLink)`
  text-decoration: none;
  font-family: 'PoppinsMedium';
  color: #fff;
  font-weight: 500;
  transition: color 0.2s;
`

const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-self: end;
  grid-column: 3;
  @media (max-width: 900px) {
    display: none;
  }
`

const LanguageButton = styled.button`
  background: none;
  border: none;
  font-size: 0.9rem;
  color: #fff;
  cursor: pointer;
  font-family: 'PoppinsMedium';
`

const DiscoverButton = styled.button`
  background: #fff;
  border: 1px solid #333;
  border-radius: 20px;
  padding: 0.5rem 1rem;
  color: #000;
  font-size: 1.2rem;
  font-weight: 600;
  text-decoration:none;
  cursor: pointer;
  font-family: 'MongoGrotesqueLight';
  transition: background-color 0.2s, color 0.2s;
`

const DiscoverButtonCard = styled.button`
  background: #fff;
  border: 1px solid #333;
  border-radius: 20px;
  padding: 0.5rem 2rem;
  color: #000;
  font-size: 1rem;
  font-weight: 600;
  text-decoration:none;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
  &:hover {
    background: black;
    color: white;
    border-color: white;
    transition: background 0.5s ease;
  }
`

const BurgerButton = styled.button`
  display: none;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 10;
  @media (max-width: 900px) {
    display: block;
    justify-self: end;
  }
`

const BurgerIcon = styled.img`
  width: 30px;
  height: auto;
`

const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100vh;
  background: rgba(0,0,0,0.5);
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
  z-index:5;
  overflow:hidden;
  
`

const MobileMenu = styled.div`
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  background: rgba(0,0,0,0.5);
  z-index: 6;

  a, button {
    color: #fff;
    font-size: 1.2rem;
  }
  ${DiscoverButton} {
    background: #fff;
    color: #000;
  }
`


const PageContainer = styled.div`
  min-height: 100vh;
  background: black;
  display: flex;
  padding-bottom: 10%;
  flex-direction: column;

  @media (max-width: 900px) {
    overflow: hidden;
    padding-bottom: 0;
  }
`

const Content = styled.div`
  flex: 1;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  @media (max-width: 900px) {
    overflow: hidden;
    padding-bottom: 8%;
  }
`

const TopTitleWrapper = styled.div`
  height: 150px;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: -2.5%;
  
  @media (max-width: 900px) {
    height: 150px;
  }

`

const SubtitleWrapper = styled.div`
  overflow: hidden;
  display: inline-block;
  height: 40px;
`

const Title = styled.p`
  font-size: 6.5rem;
  color: #fff;
  font-family: 'ZombiePunksRegular';
  margin: 0;
  width: 100%;

  visibility: hidden;
  @media (max-width: 410px) {
    font-size: 5rem;
  }
  @media (max-width: 900px) {
    font-size: 4.5rem;
  }
`

const Subtitle = styled.p`
  font-size: 1.1rem;
  color: #ddd;
  font-family: 'PoppinsMedium';
  margin-bottom: 2rem;

  /* hide until ready to animate */
  visibility: hidden;
`

const IconRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 10px;
  margin-bottom: 2rem;
`

const Icon = styled.img`
  width: 20px;
  height: 20px;
`

const LargeIcon = styled.img`
  width: 350px;
  height: 350px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: rotate(20deg);
  @media (max-width: 1024px) {
  display:none;
  }
`

const LargeIcon2 = styled.img`
  width: 250px;
  height: 250px;
  position: absolute;
  right: 0;
  top: 50%;
   @media (max-width: 1024px) {
  display:none;
  }
`

const ImageStack = styled.div`
  display: grid;
  grid-template-areas: 'stack';
  place-items: center;
  margin-top: 4rem;

`  

const LayerWrapper = styled.div<{
  angle: number
  offset: number
  offsetY: number
}>`
  grid-area: stack;
  transform:
    translateX(${({ offset }) => offset}%)
    translateY(${({ offsetY }) => offsetY}px)
    rotate(${({ angle }) => angle}deg);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  opacity: 0;
  animation: ${fadeIn} 0.8s ease-in-out forwards paused;
  &:nth-child(1) { animation-delay: 0s;   }
  &:nth-child(2) { animation-delay: 0.2s; }
  &:nth-child(3) { animation-delay: 0.4s; }
  &:nth-child(4) { animation-delay: 0.6s; }
`

const LayerImage = styled.img`
  display: block;
  width: 300px;
  height: 400px;
  @media (max-width: 900px) {
    width: 150px;
  height: 200px;
    }
    
`

const Spacer = styled.div`
  height: 10rem;
  @media (max-width: 900px) {
    height: 2rem;
  }
`

const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  @media (min-width: 1500px) {
    justify-content: center;
    gap:50px;
  }
  @media (max-width: 900px) {
    flex-direction: column;
    width: 100%;
    margin-left: 0;
    justify-content: center;
  }
`

const ContentCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;

  @media (max-width: 900px) {
    padding: 2rem;
    padding-left:1rem;
    padding-right:1rem;
  }
`

const ContentImage = styled.img`
  width: 450px;
  height: 600px;
  margin-right: 5%;

  @media (max-width: 900px) {
    width: 350px;
    height: 400px;
  }
`

const BottomTitleWrapper = styled.div`
  overflow: hidden;
  display: inline-block;
  padding-bottom: 10%;
  padding-top: 10%;
  @media (min-width: 1500px) {
     padding-top: 0%;
   }
`

const Title2 = styled.p`
  font-size: 8rem;
  color: #fff;
  font-family: 'MongoGrotesqueLight';
  margin: 0;
 
  @media only screen and (min-device-width: 900px)and (max-device-width: 1024px) {

    font-size: 7rem;
   
 }

  @media (max-width: 900px) {
    display: none;
  }
`

const Title3 = styled.p`
  display: none;
  @media (max-width: 900px) {
    display: block;
    font-size: 5rem;
    color: #fff;
    font-family: 'MongoGrotesqueLight';
    margin: 0;
    text-align: center;
  }
  @media (max-width: 410px) {
   
    font-size: 4rem;
  }
`

const ContentSubtitle = styled.p`
  margin: 0;
  font-size: 1rem;
  color: #ccc;
  @media only screen and (min-device-width: 900px)and (max-device-width: 1024px) {

    margin-top: -2%;
      
   
 }
  @media (max-width: 900px) {
    display: none;
  }
`

const ContentSubtitleMob = styled.p`

  display: none;
  @media (max-width: 900px) {
    margin: 0;
    display:flex;
    font-size: 1rem;
    color: #ccc;
  }
`



const layers = [
  { angle: -15, offset: -120, offsetY: 0 },
  { angle:  -5, offset:  -45, offsetY: -30 },
  { angle:   2, offset:   45, offsetY: -30 },
  { angle:   5, offset:  120, offsetY: -10 }
]

const JockerIntro: React.FC = () => {
  const topTitleRef     = useRef<HTMLParagraphElement>(null)
  const topSubtitleRef  = useRef<HTMLParagraphElement>(null)
  const titleDesktopRef = useRef<HTMLParagraphElement>(null)
  const titleMobileRef  = useRef<HTMLParagraphElement>(null)
  const [isOpen, setIsOpen] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

  const cards = [C2, C3, C4, C1]

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 900);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useLayoutEffect(() => {
    gsap.registerPlugin(ScrollTrigger)

    if (titleDesktopRef.current) {
      gsap.fromTo(
        titleDesktopRef.current,
        { yPercent: 100 },
        {
          yPercent: 0,
          duration: 1,
          ease: 'power4.out',
          scrollTrigger: {
            trigger: titleDesktopRef.current,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        }
      )
    }
    if (titleMobileRef.current) {
      gsap.fromTo(
        titleMobileRef.current,
        { yPercent: 100 },
        {
          yPercent: 0,
          duration: 1,
          ease: 'power4.out',
          scrollTrigger: {
            trigger: titleMobileRef.current,
            start: isMobile ? 'top 95%' : 'top 80%',
            toggleActions: 'play none none none',
          },
        }
      );
    }

    const startAnim = () => {
      document
        .querySelectorAll<HTMLDivElement>('#layer-stack .layer-wrapper')
        .forEach(el => {
          el.style.animationPlayState = 'running'
        })

      if (topTitleRef.current && topSubtitleRef.current) {
        gsap.set(
          [topTitleRef.current, topSubtitleRef.current],
          { yPercent: 150, visibility: 'visible' }
        )

        const cardsDoneAt = 0.9

        gsap.timeline({ delay: cardsDoneAt })
          .to(topSubtitleRef.current, {
            yPercent: 0,
            duration: 0.6,
            ease: 'power4.out',
          })
          .to(topTitleRef.current, {
            yPercent: 0,
            duration: 0.6,
            ease: 'power4.out',
          }, '-=0.3')
      }
    }

    window.addEventListener('pageTransitionFinished', startAnim, { once: true })
    return () => {
      window.removeEventListener('pageTransitionFinished', startAnim)
    }
  }, [])

  return (
    <PageContainer>
    <NavbarContainer>
      <LogoWrapper to="/"><Logo src={LogoImg} alt="Logo" /></LogoWrapper>
      <NavLinks>
        <StyledNavLink to="/aboutus">À PROPOS DE NOUS</StyledNavLink>
        <StyledNavLink to="/jockerclub">JOKER CLUB</StyledNavLink>
        <StyledNavLink to="/">MULTISHOP</StyledNavLink>
        <StyledNavLink to="/contactus">CONTACT</StyledNavLink>
      </NavLinks>
      <RightActions>
        {/* <LanguageButton>ENG</LanguageButton>*/}
        <DiscoverButton>JE DÉCOUVRE</DiscoverButton>
      </RightActions>
      <BurgerButton onClick={() => setIsOpen(!isOpen)}>
        <BurgerIcon src={BurgerImg} alt="Menu" />
      </BurgerButton>
    </NavbarContainer>

    {isOpen && (
      <>
        <Overlay onClick={() => setIsOpen(false)} />
        <MobileMenu>
          <StyledNavLink to="/aboutus" onClick={() => setIsOpen(false)}>
            À PROPOS DE NOUS
          </StyledNavLink>
          <StyledNavLink to="/jockerclub" onClick={() => setIsOpen(false)}>
            JOKER CLUB
          </StyledNavLink>
          <StyledNavLink to="/" onClick={() => setIsOpen(false)}>
            MULTISHOP
          </StyledNavLink>
          <StyledNavLink to="/contactus" onClick={() => setIsOpen(false)}>
            CONTACTEZ-NOUS
          </StyledNavLink>
        {/* <LanguageButton onClick={() => setIsOpen(false)}>ENG</LanguageButton>  */}
          <DiscoverButton onClick={() => setIsOpen(false)}>JE DÉCOUVRE</DiscoverButton>
        </MobileMenu>
      </>
    )}

      <Content>
        <IconRow>
          <Icon src={Icon2} alt="Icon 2" />
          <Icon src={Icon3} alt="Icon 3" />
          <Icon src={Icon1} alt="Icon 1" />
          <Icon src={Icon4} alt="Icon 4" />
        </IconRow>

        <TopTitleWrapper>
          <Title ref={topTitleRef}>JOKER CLUB</Title>
        </TopTitleWrapper>
        <SubtitleWrapper>
          <Subtitle ref={topSubtitleRef}>
            La collection NFT de Partouche Multiverse
          </Subtitle>
        </SubtitleWrapper>
{/* 
        <LargeIcon  src={Icon5} alt="Icon 1" />
        <LargeIcon2 src={Icon6} alt="Icon 2" /> */}

        <ImageStack id="layer-stack">
          {layers.map((layer, i) => (
            <LayerWrapper
              className="layer-wrapper"
              key={i}
              angle={layer.angle}
              offset={layer.offset}
              offsetY={layer.offsetY}
            >
              <LayerImage src={cards[i]} alt={`Layer ${i + 1}`} />
            </LayerWrapper>
          ))}
          <DiscoverButtonCard onClick={() => window.open('https://opensea.io/collection/jokerclub-1', '_blank')}>OpenSea</DiscoverButtonCard>
        </ImageStack>

        <Spacer />

        <ContentRow>
          <BottomTitleWrapper>
            <Title3 ref={titleMobileRef}>
              PORTAIL VERS <br /> UN NOUVEAU MONDE
            </Title3>
          </BottomTitleWrapper>

          <ContentImage src={ImgImp} alt="Illustration" />

          <ContentCard>
            <BottomTitleWrapper>
              <Title2 ref={titleDesktopRef}>
                PORTAIL VERS <br /> UN NOUVEAU MONDE
              </Title2>
            </BottomTitleWrapper>
            <ContentSubtitle>
            En mars 2023, Partouche Multiverse a lancé Joker Club, sa toute première<br /> collection NFT : 4 444 Jokers uniques sur la blockchain Ethereum, incarnant <br />une nouvelle vision du divertissement.<br /><br />
            Le Joker Club, c’est bien plus qu’une collection : c’est une communauté 3.0 <br />en marche vers un avenir décentralisé. Ici, le divertissement est sacré, le Joker <br />est vénéré, et chaque NFT ouvre l’accès à des avantages exclusifs au sein de <br />l’écosystème Partouche et auprès de ses partenaires.<br /><br />
            Le mouvement est lancé. Le temps du Joker Spirit est arrivé. 
            </ContentSubtitle>
            <ContentSubtitleMob>
            En mars 2023, Partouche Multiverse a lancé Joker Club, sa toute première collection NFT : 4 444 Jokers uniques sur la blockchain Ethereum, incarnant une nouvelle vision du divertissement.<br /><br />
            Le Joker Club, c’est bien plus qu’une collection : c’est une communauté 3.0 en marche vers un avenir décentralisé. Ici, le divertissement est sacré, le Joker est vénéré, et chaque NFT ouvre l’accès à des avantages exclusifs au sein de l’écosystème Partouche et auprès de ses partenaires.<br /><br />
            Le mouvement est lancé. Le temps du Joker Spirit est arrivé. 
            </ContentSubtitleMob>
          </ContentCard>
        </ContentRow>
      </Content>
    </PageContainer>
  )
}

export default JockerIntro